module.exports = __webpack_public_path__ + "img/img_index_banner_xkt_r@2x.37317e0d.png";